import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpEventType, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {NzMessageService} from 'ng-zorro-antd';

import { finalize, tap, catchError } from 'rxjs/operators';
import {LoadingService} from './loading/loading.service';
import {isNull} from 'util';
import {Router} from '@angular/router';
import {TokenCookieService} from './token-cookie.service';
import {AttachOrg} from '../models/org';
import {AttachPartyService} from '../services/console/attach-party.service';

@Injectable()
export class NoopInterceptor implements HttpInterceptor {


    constructor(
        private _message: NzMessageService,
        private _loading: LoadingService,
        private _token: TokenCookieService,
        private router: Router,
        private attachParty: AttachPartyService
    ) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<HttpEventType.Response>> {
        const attachOrg: AttachOrg = this.attachParty.get_party();
        // 显示加载样式
        console.log('loading.start', req.url);
        this._loading.start();


        // 额外添加 Headers 信息

        let auth_header = {};
        if (attachOrg.party_id) {
            auth_header = {'current-party-id': attachOrg.party_id};
        }

        const authReq = req.clone({
            setHeaders: auth_header
        });

        // 获取请求时的当前时间，以便后面计算请求时长
        const started = Date.now();

        return next.handle(authReq)
            .pipe(
                tap(
                    // Succeeds when there is a response; ignore other events
                    // 这里会走一到两次，异常（500、401等）时只一次，正常（状态码：200）时两次：
                    //      第一次：不管是请求正常还是异常，都会走一次这里，此时返回体 event 等于 {type: 0}，用处不大
                    //      第二次：只有请求正常时才会走这第二次，返回体 event 等于 HttpResponse 的实体，所以下面会判断当前 event 是否是 HttpResponse 的实体，如果匹配上，那就可以处理这个返回体 event；
                    //             异常时不会走这里第二次，第二次会直接被下面的 catch() 方法抓住，这样就可以处理异常信息了
                    event => {
                        if (event instanceof HttpResponse) {

                            // 更新 Headers 信息：Authorization
                            // const new_access_token = event.headers.get('Authorization');
                            // if (!isNull(new_access_token)) {
                            //     this._token.put_cookie(new_access_token);
                            // }
                        }
                    },
                    // Operation failed; error is an HttpErrorResponse
                    error => {
                    }
                ),
                catchError(err => {
                    return this.error(err);
                }),
                // Log when response observable either completes or errors
                finalize(() => {
                    // 隐藏加载样式
                    this._loading.stop();
                    console.log('loading.stop', req.url);

                    // 计算请求时长
                    const elapsed = (Date.now() - started) / 1000;
                    console.log(`%c请求 ${req.method} ${req.urlWithParams} 占用了 ${elapsed} 秒.`, 'color: #E80C7A');
                })
            );
    }

    error(err: HttpErrorResponse | any): Observable<never> {
        let errResponse: any;
        if (err.error instanceof Error) {
            // 发生客户端或网络错误.
            errResponse = {errcode: 500, errmsg: err.error.message};
        } else {

            // 发生服务端错误
            if (err.error instanceof ProgressEvent || isNull(err.error)) {
                // 发生未知错误
                errResponse = {errcode: 500, errmsg: '未知错误'};
            } else {
                // 服务端异常 or 开发者在服务端主动抛出的错误
                if (err.error.hasOwnProperty('desc') && err.error.hasOwnProperty('status')) {
                    errResponse = {errcode: err.error.status, errmsg: err.error.desc};
                } else {
                    errResponse = {errcode: 500, errmsg: err.statusText};
                }
            }
        }

        // 弹出全局提示条
        this.createMessage('warning', errResponse.errmsg);
        console.warn(err);

        if (err.status === 403) {
            this._token.remove_cookie();
            this.router.navigateByUrl('/auth/login');
        }
        return new Observable(subscriber => subscriber.error(errResponse));
    }

    createMessage(type, text) {
        this._message.create(type, `${text}`);
    }
}
